const getTimestampDateXDaysAgo = daysAgo => {
  var date = new Date();
  var last = new Date(date.getTime() - daysAgo * 24 * 60 * 60 * 1000);
  return last.getTime();
};

export default getTimestampDateXDaysAgo;
